import { create } from 'zustand';

interface AuthState {
  token: string | null;
  partnerName: string | null;
  isAuthenticated: boolean;
  isInitialized: boolean;
  login: (token: string, partnerName: string) => void;
  logout: () => void;
  initializeAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  partnerName: null,
  isAuthenticated: false,
  isInitialized: false,

  login: (token: string, partnerName: string) => {
    sessionStorage.setItem('partner_token', token);
    sessionStorage.setItem('partner_name', partnerName);
    set({ token, partnerName, isAuthenticated: true });
  },

  logout: () => {
    sessionStorage.removeItem('partner_token');
    sessionStorage.removeItem('partner_name');
    set({ token: null, partnerName: null, isAuthenticated: false });
  },

  initializeAuth: () => {
    const token = sessionStorage.getItem('partner_token');
    const partnerName = sessionStorage.getItem('partner_name');

    if (token && partnerName) {
      set({ token, partnerName, isAuthenticated: true, isInitialized: true });
      return;
    }
    set({ isInitialized: true });
  },
}));
